import React from 'react';
import ProductsPage from '../../products';

export default function FundTab() {
  return <ProductsPage />;
}
